import { render } from "./ToTopButton.vue?vue&type=template&id=17035268"
import script from "./ToTopButton.vue?vue&type=script&lang=js"
export * from "./ToTopButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__